import * as React from "react";
import { useParams } from "react-router-dom";
import { HangarsStateContainer } from "../../containers/HangarsStateContainer";
import { RampsStateContainer } from "../../containers/RampsStateContainer";
import { RampStateContainer } from "../../containers/RampStateContainer";
import { TowingEquipmentContainer } from "../../containers/TowingEquipmentContainer";
import { ScheduledRampView } from "../Schedule/ScheduledRampView/ScheduledRampView";

type Props = {
  rampId?: string;
};

export const RampSchedule: React.FC<Props> = ({ rampId }) => {
  const { id: rampIdFromRoute } = useParams();

  return (
    // Same container structure as regular Ramp component
    <RampsStateContainer isReference={false}>
      <HangarsStateContainer isReference={false}>
        <RampStateContainer
          initialState={{
            ramp_id: rampId ?? rampIdFromRoute,
            isReference: false,
          }}
        >
          <TowingEquipmentContainer>
            <ScheduledRampView
              id={rampIdFromRoute || ""}
            />
          </TowingEquipmentContainer>
        </RampStateContainer>
      </HangarsStateContainer>
    </RampsStateContainer>
  );
};